import CommentEdit from "./Edit";
import CommentList from "./List";

export default {
  list: CommentList,
  edit: CommentEdit,
};
